import React, { useContext } from 'react';
import FormGrid from '../FormGrid/FormGrid';
import Button from '../../Buttons/Button/Button';
import LabelFieldFormik from '../../Fields/LabelField/LabelFieldFormik';

import classes from './FormChangePassword.module.scss';
import Context from '../../../store/context';
import { formTypes } from '../../../store/catalogs/forms';

const passwordFields = [
  { key: 'newPassword', label: 'Contraseña nueva', type: formTypes.password, cols: 2, placeholder: '********' },
  { key: 'newPasswordConfirmation', label: 'Confirma tu nueva contraseña', type: formTypes.password, cols: 2, placeholder: '********' }
];

const FormChangePassword = ({ setFieldValue }) => {
  const {
    modal: { hideModal }
  } = useContext(Context);

  return (
    <>
      <div className={classes['second-title']}>
        <span className='semibold-16'>Establece una nueva contraseña</span>
        <span className={`medium-14 ${classes.color}`}>Recuerda que debe tener mínimo 8 caracteres.</span>
      </div>
      <FormGrid onChange={setFieldValue} fields={passwordFields} Render={LabelFieldFormik} />
      <div className={classes.buttons}>
        <Button onClick={hideModal} custom='secondary'>
          Cancelar
        </Button>
        <Button type='submit'>Restablecer contraseña</Button>
      </div>
    </>
  );
};

export default FormChangePassword;
